import { COLLAPSED_WIDTH } from "./chatWidgetLayout";

/**
 * Shared presentation for transient updates spoken by Franklin — the chat
 * nudges (`ChatNudge`) and every sonner toast (`ui/sonner.tsx`). Both read
 * these so the two surfaces cannot drift apart in font, buttons or layout.
 *
 * Layout contract: logo | message, actions on their own row BELOW the message,
 * close control pinned inside the card's top-right corner.
 */

/** Narrowest update card: the collapsed chat pill it sits above. */
export const FRANKLIN_UPDATE_MIN_WIDTH = COLLAPSED_WIDTH;

/**
 * Widest update card. Cards shrink-wrap their message between the two bounds,
 * so a longer message gets a wider line instead of a one-word last line.
 */
export const FRANKLIN_UPDATE_MAX_WIDTH = 320;

/**
 * Tailwind cannot read the constants above (class names must be literal), so
 * the bounds are spelled out here — keep them equal to MIN/MAX_WIDTH.
 */
export const FRANKLIN_UPDATE_SIZE_CLASS_NAME =
  "w-fit min-w-[min(258px,calc(100vw-2rem))] max-w-[min(320px,calc(100vw-2rem))]";

export const FRANKLIN_UPDATE_CARD_CLASS_NAME =
  "max-w-[calc(100vw-2rem)] rounded-[18px] border border-neutral-200 bg-white p-3 font-sans text-neutral-800 shadow-[0px_4px_12px_rgba(0,0,0,0.1),0px_2px_4px_rgba(0,0,0,0.06)]";

/** The message line. `text-pretty` keeps a lone short word off the last line. */
export const FRANKLIN_UPDATE_TEXT_CLASS_NAME =
  "text-pretty text-sm font-normal leading-5 text-neutral-800";

/** Secondary line under the message (toast descriptions). */
export const FRANKLIN_UPDATE_DESCRIPTION_CLASS_NAME =
  "text-pretty text-sm font-normal leading-5 text-neutral-600";

/** Room the message keeps clear on its right for the pinned close control. */
export const FRANKLIN_UPDATE_CLOSE_GUTTER_CLASS_NAME = "pr-5";

export const FRANKLIN_UPDATE_CLOSE_CLASS_NAME =
  "absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md text-neutral-400 hover:bg-neutral-100 hover:text-neutral-600";

export const FRANKLIN_UPDATE_PRIMARY_ACTION_CLASS_NAME =
  "inline-flex h-7 shrink-0 items-center justify-center rounded-lg bg-primary px-3 text-xs font-medium text-white hover:bg-primary/90";

export const FRANKLIN_UPDATE_SECONDARY_ACTION_CLASS_NAME =
  "inline-flex h-7 shrink-0 items-center justify-center rounded-lg bg-transparent px-2 text-xs font-medium text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700";

/** Speech tail used when the card is directly attached to the collapsed Franklin launcher. */
export const FRANKLIN_UPDATE_TAIL_CLASS_NAME =
  "after:absolute after:-bottom-[5px] after:right-6 after:h-3 after:w-3 after:rotate-45 after:border-b after:border-r after:border-neutral-200 after:bg-white";
